import request from '@/utils/request'

export function pageProjectList(pageCurrent, pageSize, projectCode, projectName, allowRebate, schoolCode) {
  return request({
    url: 'pay/project/pageList',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data: {
      'pageCurrent': pageCurrent,
      'pageSize': pageSize,
      'projectCode': projectCode,
      'projectName': projectName,
      'allowRebate': allowRebate,
      'schoolCode': schoolCode
    }
  })
}
export function getAllProjectList() {
  return request({
    url: 'pay/project/getAllProjectList',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// add by zhangyj 2020-05-19 查询所有推荐服务
export function getRecommendedProjectList(schoolCode) {
  return request({
    url: 'pay/project/getRecommendedProjectList',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      'schoolCode': schoolCode
    }
  })
}
export function getProjectIsAllowPayment(id) {
  return request({
    url: 'pay/project/getProjectIsAllowPayment',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data: {
      'projectId': id
    }
  })
}

